import { STEP_ROUTES } from '../constants/signup-guard-requirements-constants';

export function getRedirectForStep(completedStep: number): string {
  if (completedStep <= 0) return STEP_ROUTES[0];
  if (completedStep >= 4) return STEP_ROUTES[4];
  return STEP_ROUTES[completedStep] ?? STEP_ROUTES[0];
}
